/**
* @Description: perfectInfo
* @author XuZiYu
* @date 2021/07/16 15:00:50
*/
<template>
  <div class="wrapper">
    <ctl-header :title="'填写个人信息'"></ctl-header>

    <van-cell-group class="main">
      <van-field
        readonly
        input-align="right"
        v-model="form.subjectName"
        label="考试科目"
      >
      </van-field>
      <van-field
        @click="areaShow = true"
        size="large"
        input-align="right"
        v-model="form.examCityName"
        readonly
        label="学车省市"
        placeholder="请选择学车所在城市"
        right-icon="arrow"
      />
      <van-field
        input-align="right"
        v-model="form.stuName"
        label="学员姓名"
        maxlength="20"
        placeholder="请输入真实姓名"
        clearable
      >
      </van-field>
      <van-field
        :formatter="formatter"
        maxlength="20"
        input-align="right"
        v-model="form.stuIdcard"
        label="证件号"
        placeholder="请输入考试报名证件号"
        clearable
      >
      </van-field>
    </van-cell-group>
    <div class="rule">为了保障您的补偿权益，请输入真实信息，并确认信息填写正确再提交，以上信息将用于申请补偿时核实考生信息，若信息有误将会影响补偿结果。</div>

    <div class="bottom">
      <van-button round type="primary" :class="isSubmit || 'disabled'" :loading="loading" :disabled="loading || !isSubmit" @click="submit">提 交</van-button>
    </div>
    <van-popup
      v-model="areaShow" position="bottom">
      <van-area :area-list="areaList" :columns-num="2"
                @confirm="areaConfirm"
                @cancel="areaShow = false"
      />
    </van-popup>
  </div>
</template>

<script>
import { Area, Popup, Field, CellGroup, Button, Toast } from 'vant'
import { areaList } from '@vant/area-data'

export default {
    name: 'perfectInfo',
    components: {
        [Area.name]: Area,
        [Button.name]: Button,
        [CellGroup.name]: CellGroup,
        [Field.name]: Field,
        [Popup.name]: Popup,
        [Toast.name]: Toast
    },
    data () {
        return {
            areaShow: false,
            loading: false,
            isSubmit: false,
            areaList: areaList,
            form: {
                subjectName: '科目一、科目四',
                stuIdcard: '',
                stuName: '',
                examCityCode: '',
                examCityName: '',
                vipUserId: ''
            }
        }
    },
    watch: {
        form: {
            handler () {
                this.isSubmit = !!this.form.examCityCode && !!this.form.stuIdcard && !!this.form.stuName
            },
            deep: true
        }
    },
    methods: {
        formatter (s) {
            let pattern = new RegExp("[`~!@#$^&*()=|{}'\\s*:;',\\[\\].<>/?~！@#￥……&*（）\\-\\\\\\\\——|{}【】‘；：/\"/”“'。，、？%+_]")
            let rs = ''
            for (let i = 0; i < s.length; i++) {
                rs = rs + s.substr(i, 1).replace(pattern, '')
            }
            return rs
        },
        // 选择省市
        areaConfirm (v) {
            this.form.examCityCode = v[1].code
            this.form.examCityName = v[1].name
            this.areaShow = false
        },
        // 返回
        goBack () {
            this.$router.back()
        },
        submit () {
            this.$api.perfectInfo(this.form).then(res => {
                if (res.status) {
                    this.$router.replace({ name: 'ensureInfoDetail' })
                } else {
                    Toast(res.message)
                }
            })
        }
    },
    created () {
        this.form.vipUserId = this.$route.query.vipUserId
    },
    mounted () {

    }
}
</script>

<style lang="scss" scoped>
  *{
    font-family: PingFang SC;
  }

  /deep/ {
    .van-cell-group::after{
      border-width:0;
    }

    .van-cell{
      padding: 20px 15px;
    }

    .van-field__label{
      font-size: 15px;
      font-weight: 400;
      color: #333333;
    }
    .van-field__control::placeholder{
      font-size: 15px;
      font-weight: 400;
      color: #999999;
    }
    .van-field__control{
      font-size: 15px;
      font-weight: 400;
      color: #53CB85;
    }
    .icon-clear{
      width: 18px;
      height: 18px;
    }
    .van-field__body{
      display: flex;
      align-items: center;
    }
    .van-field__right-icon{
      display: flex;
      align-items: center;
    }
    .van-cell:last-child::after{
      display: block;
    }
  }

  .van-button{
    width: 345px;
    height: 43px;
    margin: 15px auto;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.3rem;
    opacity: 1;
    border: 0;
    line-height: 1;
    border-radius:21px;
    background-color: #53CB85;
    .van-button__text{
      font-size: 17px;
      font-weight:400;
      color:#FFFFFF;
    }
  }

  .disabled{
    background:#CCCCCC;
  }

  .rule{
    margin-top: 20px;
    padding: 0 15px;
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    line-height: 24px;
  }
</style>
